import { useState, useEffect } from 'react';
import { makeGetCall } from '../utils/helper';

interface CenterOption {
  label: string;
  value: string;
}

export const useSites = () => {
  const [centers, setCenters] = useState<CenterOption[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchSites = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await makeGetCall('/center-options');

      if (response?.data?.success) {
        setCenters(response.data.data || []);
      } else {
        throw new Error(response?.data?.message || 'Failed to fetch sites');
      }
    } catch (err: any) {
      console.error('Error fetching sites:', err);
      setError(err.message || 'Failed to fetch sites');
      setCenters([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSites();
  }, []);

  const refetch = () => {
    fetchSites();
  };

  return {
    centers,
    loading,
    error,
    refetch
  };
};
